<template lang="pug">
  b-container(fluid)
    b-row
      b-col(cols="12")
        b-card.w-100(no-body)
          div(slot="header")
            b-row
              b-col(col, cols="12", sm="6", md="3")
                b-button-group(size="sm")
                  b-btn(:variant="requestState === 'requested' ? 'primary' : 'default'", @click="requestState = 'requested'") 요청리스트&nbsp;&nbsp;
                    b-badge(variant="light") {{counts.requested}}
                  b-btn(:variant="requestState === 'approved' ? 'primary' : 'default'", @click="requestState = 'approved'") 승인됨&nbsp;&nbsp;
                    b-badge(variant="light") {{counts.approved}}
                  // b-btn(:variant="requestState === 'on-work' ? 'primary' : 'default'", @click="requestState = 'on-work'") 작업중
                  b-btn(:variant="requestState === 'reject' ? 'primary' : 'default'", @click="requestState = 'reject'") 반려&nbsp;&nbsp;
                    b-badge(variant="light") {{counts.reject}}
                  b-btn(:variant="requestState === 'completed' ? 'primary' : 'default'", @click="requestState = 'completed'") 작업완료
              // b-col.ml-auto(col, cols="12", sm="6", md="5")
              //   b-input-group.mx-1.w-100(size="sm")
              //     template(slot="prepend")
              //       b-dropdown(:text="$t(search.key.text)", size="sm", variant="grey-200")
              //         b-dropdown-item(
              //           v-for="opt in search.options",
              //           :key="opt.value",
              //           @click="setSearchKey(opt)") {{$t(opt.text)}}
              //     b-form-input(v-model="search.value", @keypress.enter="searchHandler")
              //     b-input-group-append
              //       b-btn(@click="searchHandler") {{$t('search')}}
          b-table(
            ref="ticketTable",
            :fields="fields",
            :items="tickets",
            :current-page="page.current",
            :per-page="page.per",
            :empty-text="$t('no-content')",
            tbody-class="lmm-table-body",
            sort-by="reqr_created_date",
            :sort-desc="true",
            show-empty)
            template(slot="state", slot-scope="row")
              div.state-label(:class="`state-n${row.item.state}`") {{row.item.state | ticketState}}
            template(slot="reqr_created_date", slot-scope="row") {{row.item.reqr_created_date | moment('YY-MM-DD')}}
            template(slot="reqr_user_name", slot-scope="row")
              div {{row.item.reqr_user_company}}
              div {{row.item.reqr_user_name}} ({{row.item.reqr_user_part}})
            template(slot="reqr_worktime", slot-scope="row")
              div {{row.item.reqr_work_startdate | moment('YY-MM-DD HH:mm:ss')}} 부터
              div {{row.item.reqr_work_enddate | moment('YY-MM-DD HH:mm:ss')}} 까지
            template(slot="devices", slot-scope="row")
              div(v-for="dev in row.item.devices", :key="dev.pk") {{dev.device_name}}
            template(slot="reqr_appr", slot-scope="row")
              div(:class="{moved: row.item.appr_mgr.pk && (row.item.appr_mgr.pk !== row.item.reqr_appr_mgr.pk)}") {{row.item.reqr_appr_mgr.name}} {{row.item.reqr_appr_mgr.position}} ({{row.item.reqr_appr_mgr.part}})
              div(v-if="row.item.appr_mgr.pk") 
                | {{row.item.appr_mgr.name}} {{row.item.appr_mgr.position}} ({{row.item.appr_mgr.part}})
            template(slot="action", slot-scope="row")
              b-button-group(size="sm")
                b-btn(@click="showDetail(row.item, 'detail')") 자세히
                template(v-if="row.item.state === 0 || row.item.state === 1")
                  b-btn(@click="showDetail(row.item, 'approve')") 승인
                  b-btn(@click="showDetail(row.item, 'reject')") 반려
                template(v-if="row.item.state === 2")
                  b-btn(@click="showDetail(row.item, 'terminate')") 강제종료

          div.d-flex.justify-content-between(slot="footer")
            div
              b-form-select(
                size="sm",
                v-model="page.per",
                :options="page.perOptions")
            b-pagination(
              size="sm",
              :total-rows="page.total",
              :per-page="page.per",
              v-model="page.current",
              class="my-0 float-right"
            )
    b-modal(
      size="lg",
      v-model="detail.show",
      header-class="lmm-common-popup-header",
      no-close-on-backdrop)
      template(slot="modal-header")
        img.logo(:src="`${AppState.Path.image}/main_logo.png`")
      div(v-if="detail.show")
        div.request-detail-item
          div.request-detail-label 요청자
          div.request-detail-body
            div {{detail.ticket.reqr_user_company}} {{detail.ticket.reqr_user_name}} ({{detail.ticket.reqr_user_part}})
              span.temp-account(v-if="detail.ticket.worker.mgrid") 임시계정: {{detail.ticket.worker.mgrid}}
        div.request-detail-item
          div.request-detail-label 작업일
          div.request-detail-body
          | {{detail.ticket.reqr_work_startdate | moment('YY-MM-DD HH:mm:ss')}} 부터
          | {{detail.ticket.reqr_work_enddate | moment('YY-MM-DD HH:mm:ss')}} 까지
        div.request-detail-item
          div.request-detail-label 요청장비
          div.request-detail-body
            router-link.device-label(
              v-for="dev in detail.ticket.devices", 
              :key="dev.pk", 
              :to="{name: 'device-detail', params: {groupPk: 'all', devicePk: dev.pk}}") {{dev.device_name}}
        div.request-detail-item
          div.request-detail-label 작업내용
          div.request-detail-body
            pre {{detail.ticket.reqr_work_reason}}
        div.request-detail-item
          div.request-detail-label 상태
          div.request-detail-body  {{detail.ticket.state | ticketState}}
        div.request-detail-item
          div.request-detail-label 승인자
          div.request-detail-body
            div(:class="{moved: detail.ticket.appr_mgr.pk && (detail.ticket.appr_mgr.pk !== detail.ticket.reqr_appr_mgr.pk)}") 
              | {{detail.ticket.reqr_appr_mgr.name}} {{detail.ticket.reqr_appr_mgr.position}} ({{detail.ticket.reqr_appr_mgr.part}})
            div(v-if="detail.ticket.appr_mgr.pk") 
              | {{detail.ticket.appr_mgr.name}} {{detail.ticket.appr_mgr.position}} ({{detail.ticket.appr_mgr.part}})
        
      template(slot="modal-footer")
        b-btn(v-if="detail.option === 'detail'" size="sm", @click="detail.show = false") {{$t('close')}}
        template(v-else-if="detail.option === 'approve'")
          b-form-textarea(
            id="textarea"
            v-model="detail.extra"
            placeholder="추가 메세지가 있다면 적어주세요"
            rows="1"
            max-rows="6")
          b-btn(size="sm", variant="primary", @click="approveTicket") 승인
          b-btn(size="sm", @click="detail.show = false") {{$t('cancel')}}
        template(v-else-if="detail.option === 'reject'")
          b-form-textarea(
            id="textarea"
            v-model="detail.extra"
            placeholder="반려 사유를 적어주세요"
            rows="1"
            max-rows="6")
          b-btn(size="sm", variant="danger", @click="rejectTicket") 반려
          b-btn(size="sm", @click="detail.show = false") {{$t('cancel')}}
        template(v-else-if="detail.option === 'terminate'")
          b-form-textarea(
            id="textarea"
            v-model="detail.extra"
            placeholder="강제종료 사유를 적어주세요"
            rows="1"
            max-rows="6")
          b-btn(size="sm", variant="danger", @click="terminateTicket") 강제종료
          b-btn(size="sm", @click="detail.show = false") {{$t('cancel')}}
</template>

<script>
import Switches from "vue-switches"
import { UsersAPI, AccessTicketAPI } from "../../api"

export default {
  name: "ticket-request-component",
  components: { Switches },
  methods: {
    showDetail(ticket, option) {
      this.detail.ticket = ticket
      this.detail.option = option
      this.detail.extra = ""
      this.detail.show = true
    },
    approveTicket() {
      let { ticket, extra } = this.detail
      // validate
      let params = {
        ticket_pk: ticket.id,
        action_type: "approve",
        extra,
      }
      AccessTicketAPI.post("", params).then(resp => {
        if (resp.data.status !== 200) {
          return this.$awn.alert("상태 업데이트에 실패했습니다")
        }
        this.detail.show = false
        this.$refs.ticketTable.refresh()
        this.$awn.success("승인 처리 됬습니다")
      })
    },
    rejectTicket() {
      let { ticket, extra } = this.detail
      // validate
      let params = {
        ticket_pk: ticket.id,
        action_type: "reject",
        extra,
      }
      AccessTicketAPI.post("", params).then(resp => {
        if (resp.data.status !== 200) {
          return this.$awn.alert("상태 업데이트에 실패했습니다")
        }
        this.detail.show = false
        this.$refs.ticketTable.refresh()
        this.$awn.success("반려 처리 됬습니다")
      })
    },
    terminateTicket() {
      let { ticket, extra } = this.detail
      // validate
      let params = {
        ticket_pk: ticket.id,
        action_type: "terminate",
        extra,
      }
      AccessTicketAPI.post("", params).then(resp => {
        if (resp.data.status !== 200) {
          return this.$awn.alert("상태 업데이트에 실패했습니다")
        }
        this.detail.show = false
        this.$refs.ticketTable.refresh()
        this.$awn.success("강제종료 처리 됬습니다")
      })
    },
    searchHandler() {
      this.$refs.ticketTable.refresh()
    },
    tickets(ctx) {
      this.pageMounted = false
      let params = {
        by: ctx.sortBy,
        limit: ctx.perPage,
        offset: (ctx.currentPage - 1) * ctx.perPage,
        order: ctx.sortDesc ? "desc" : "asc",
        state: this.requestState,
      }

      if (this.search.value) {
        params.search_key = this.search.key.value
        params.search_value = this.search.value
      }

      return AccessTicketAPI.get("", { params }).then(resp => {
        setTimeout(() => {
          this.pageMounted = true
        }, 300)
        this.page.total = resp.data.meta.total_count
        this.counts.requested = resp.data.meta.requested
        this.counts.approved = resp.data.meta.approved
        this.counts.reject = resp.data.meta.reject
        return resp.data.objects
      })
    },
    activeChanged(key, value, user) {
      if (!this.pageMounted) return
      key += ""
      let params = { flag_active: value }
      UsersAPI.put(key, params)
      let readable = value ? this.$t("active") : this.$t("inactive")
      this.$awn.success(this.$t("user_active_changed", { name: user.name, status: readable }))
    },
    remoteUser(user) {
      let params = {
        title: "LinkMeMine",
        context: { path: "delete_user_confirm" },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "danger",
          text: { path: "delete" },
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key !== "submit") return
        UsersAPI.delete(`${user.pk}`).then(resp => {
          this.$awn.success(this.$t("deleted_user"))
          this.$refs.userTable.refresh()
        })
      })
    },
    setSearchKey(opt) {
      this.search.value = null
      this.search.key = opt
    },
  },
  watch: {
    requestState() {
      this.page.current = 1
      this.searchHandler()
    },
  },
  mounted() {
    this.AppState.$on("ticket-state-change", () => {
      this.$refs.ticketTable.refresh()
    })
  },
  beforeDestroy() {
    this.AppState.$off("ticket-state-change")
  },
  data() {
    return {
      pageMounted: false,
      fields: [
        { key: "state", label: "상태", thClass: "text-center", tdClass: "text-center" },
        { key: "reqr_created_date", label: "요청일", thClass: "text-center", tdClass: "text-center" },
        { key: "reqr_user_name", label: "요청인", thClass: "text-center", tdClass: "text-center" },
        { key: "reqr_worktime", label: "요청시간", thClass: "text-center", tdClass: "text-center" },
        { key: "devices", label: "요청장비" },
        { key: "reqr_appr", label: "승인자", thClass: "text-center", tdClass: "text-center" },
        { key: "action", label: "", thClass: "text-right", tdClass: "text-right" },
      ],
      page: {
        total: 0,
        current: 1,
        per: 10,
        perOptions: [
          { value: 5, text: "5" },
          { value: 10, text: "10" },
          { value: 15, text: "15" },
          { value: 20, text: "20" },
        ],
      },
      search: {
        key: { value: "mgrid", text: "user" },
        options: [
          { value: "mgrid", text: "user" },
          { value: "name", text: "name" },
          { value: "department", text: "department" },
        ],
        value: null,
      },
      requestState: "requested",
      detail: {
        show: false,
        ticket: {},
        option: "detail",
        extra: null,
      },
      counts: {
        requested: 0,
        approved: 0,
        reject: 0,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.request-detail-item {
  position: relative;
  padding-left: 80px;
  margin-bottom: 10px;
}
.request-detail-label {
  position: absolute;
  top: 0;
  left: 0;
  width: 80px;
}
.request-detail-body {
  pre {
    border: 1px solid #dfdfdf;
    border-radius: 3px;
    padding: 4px;
  }
  .device-label {
    display: inline-block;
    border: 1px solid #c1c1c1;
    padding: 2px 6px;
    border-radius: 3px;
    background-color: #ebebeb;
    cursor: pointer;
    margin-right: 4px;
    &:hover {
      text-decoration: none;
    }
  }
}

.state-label {
  border: 1px solid #bbb;
  border-radius: 2px;
  background-color: #ebebeb;
  display: inline-block;
  padding: 0px 6px;
  &.state-n0 {
    border-color: #94bbde;
    background-color: #d3e7f7;
    color: #6276b1;
  }
  &.state-n1 {
    border-color: #94bbde;
    background-color: #d3e7f7;
    color: #6276b1;
  }
  &.state-n2 {
    border-color: #c0ea8f;
    background-color: #ebffd4;
    color: #7fb73e;
  }
  &.state-n4 {
    border-color: #94bbde;
    background-color: #d3e7f7;
    color: #6276b1;
  }
}

.moved {
  text-decoration: line-through;
  color: #b3b3b3;
}

.temp-account {
  display: inline-block;
  padding: 0px 6px;
  margin: 0 10px;
  color: #888;
  background-color: #ebebeb;
  border: 1px solid #ebebeb;
  font-size: 12px;
}
</style>
